export default {
    common:{
        searchPlaceHolder:'请输入关键字',
        buttonText:'搜索',
        contactText:'联系我们',
        swichLang:'切换英文',
        plsaseChoose:'请选择',
        product:'产品',
        news:'新闻'
    },
    home:{
        nodata:'暂无',
        more:'更多',
        detail:'详情',
        news:'新闻公告',
        responsibility:'社会责任',
        products:'安邦产品'
    },
    about:'关于我们',
    nowAddress:'当前位置',
    noData:'暂无数据',
    products:{
        title:'产品中心',
        brand:'安邦',
        matName:'药品名',
        generalName:'通用名',
        checkDetail:'查看详情'
    },
    responsibility:'社会责任',
    culture:{
        title:'企业文化',
        checkDetail:'查看详情',
        download:'下载'
    },
    rd:'研发中心',
    member:'集团成员',
    artical:'招贤纳士',
}